import { render, staticRenderFns } from "./TrainingRec.vue?vue&type=template&id=25abc53a&scoped=true&"
import script from "./TrainingRec.vue?vue&type=script&lang=js&"
export * from "./TrainingRec.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRec.vue?vue&type=style&index=0&id=25abc53a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25abc53a",
  null
  
)

export default component.exports